import { Trans } from 'next-i18next';
export const SearchDefaultScreen = ({
  onLinkClick
}: {
  onLinkClick?: () => void;
}) => {
  return <div className="flex size-full flex-col items-center justify-between pb-xl pt-4xl" data-sentry-component="SearchDefaultScreen" data-sentry-source-file="SearchDefaultScreen.tsx">
      <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer" className="my-xl" onClick={onLinkClick}>
        <img src="/assets/pexels_logo.webp" alt="Pexels Logo" className=" w-[220px] opacity-10" />
      </a>
      <div className="text-assistive0 text-body-md-medium">
        <Trans i18nKey="build:image.searchTab.footer" components={{
        anchor: <a href="https://www.pexels.com/license/" className="text-link" target="_blank" rel="noopener noreferrer" onClick={onLinkClick} />
      }} data-sentry-element="Trans" data-sentry-source-file="SearchDefaultScreen.tsx" />
      </div>
    </div>;
};